<template>
  <div class="departures-container">
    <table cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th>Linha</th>
          <th>Próximos horários</th>
        </tr>
      </thead>
      <tbody :class="{animate: animateClassVisible && totalPages > 1}">
        <tr name="fade" v-for="t in pages[currentPage]" :key="t.tripId" :class="{'has-alerts': t.alerts.length > 0}">
          <td>
            <div class="trip">
              <div class="short-name" :style="{color: t.textColor, backgroundColor: t.color}">
                {{t.shortName}}
              </div>
              <div>
                <div class="long-name">{{t.longName}}</div>
                <div class="headsign">{{t.headsign}}</div>
              </div>
            </div>
            <div class="alerts" v-if="t.alerts.length > 0">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"/>
              </svg>
              <div class="alerts-list">
                <div class="alert-title" v-for="alert in t.alerts" :key="alert.key">
                  <i>Veja no aplicativo:</i> {{alert.header}}
                </div>
              </div>
            </div>
          </td>
          <td class="departure-times">
            <DepartureTime :panelConfig="panelConfig" :departure="d" :first="index === 0"
             v-for="(d, index) in t.times.slice(0,3)"
             :key="d.nextDay+';'+(d.minutes||d.time)+';'+(d.vehicleId||0)"></DepartureTime>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="footer" v-if="totalPages > 1">
      <div class="page-bullet" :class="{current: currentPage === index}"
       v-for="(n, index) in totalPages" :key="index"></div>
    </div>

    <div class="no-trips" v-if="stopData.trips.length === 0">
      <svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg">
        <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm128 1247v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zm-2-344l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z"/>
      </svg>
      Nenhuma previsão para este ponto
    </div>
  </div>
</template>

<script>
import DepartureTime from './DepartureTime';

export default {

  components: { DepartureTime },

  props: ['panelConfig', 'stopData'],

  watch: {
    stopData: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateDisplay(true);
      }
    }
  },

  data() {
    return {
      isDesktop: false,
      displayRows: -1,
      trips: null,
      pages: [],
      maxPages: 3,
      totalPages: 1,
      currentPage: 0,
      animateClassVisible: false,
    }
  },

  methods: {
    updateDisplay(force) {
      this.isDesktop = window.innerWidth > 600;

      let rowsPerPage;

      if (this.isDesktop) {
        const height = {
          window: window.innerHeight,
          header: document.querySelector('.header').clientHeight,
          thead: document.querySelector('.departures-container table thead').clientHeight,
        }

        let rowHeight = document.querySelector('.departures-container table tbody tr:not(.has-alerts)')?.offsetHeight;

        if (!rowHeight) {
          const h = document.querySelector('.departures-container table tbody tr.has-alerts')?.offsetHeight;

          if (h > 0) {
            rowHeight = h - document.querySelector('.departures-container table tbody tr.has-alerts .alerts')?.offsetHeight;
          }
        }

        rowsPerPage = Math.floor((height.window - height.header - height.thead - 10) / rowHeight);
      } else {
        rowsPerPage = 9999;
      }

      if (force || this.displayRows !== rowsPerPage) {
        this.changeDisplayRows(rowsPerPage);
      }
    },

    changeDisplayRows(rowsPerPage) {
      this.displayRows = rowsPerPage;

      this.stopData.trips.forEach(t => (t.rowHeight = t.alerts.length > 0 ? 2 : 1));

      this.pages = [];
      let page = [];
      let pageRows = 0;

      const trips = [...this.stopData.trips];

      while (trips.length >= 0) {
        if (trips.length === 0 || pageRows + trips[0].rowHeight > rowsPerPage) {
          this.pages.push(page);
          page = [];
          pageRows = 0;

          if (trips.length === 0 || this.pages.length >= this.maxPages) break;
        }

        pageRows += trips[0].rowHeight;
        page.push(trips.shift());
      }

      this.totalPages = this.pages.length;
    }
  },

  created() {
    this.maxPages = this.panelConfig.maxPages || 3;
    this.pages = [this.stopData.trips];

    window.addEventListener('resize', this.updateDisplay);

    setTimeout(this.updateDisplay);

    if (document.fonts) {
      document.fonts.onloadingdone = this.updateDisplay;
    }

    setInterval(() => {
      // add animate class to the table
      this.animateClassVisible = true;

      // remove animate class
      setTimeout(() => { this.animateClassVisible = false }, 1000);

      // delay the change of the current page to wait for the animation
      setTimeout(() => {
        this.currentPage++;
        if (this.currentPage >= this.totalPages) this.currentPage = 0;
      }, 150);
    }, 10000);
  }

};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-bottom: 1px solid #ddd;

  tr:nth-child(even) {
    background: #f4f4f4;
  }
  tr:nth-child(odd) {
    background: #fff;
  }

  th {
    padding: .2em .5em;
    text-align: left;
    color: #fff;
    background: #333e49;
    background: linear-gradient(0deg, #333e49 0%, #6b737b 100%);

    &:nth-of-type(2) {
      text-align: center;
    }
  }

  td {
    padding: .4em .5em;
    border-top: 1px solid #ddd;
  }
}
.trip {
  display: flex;
}
.short-name {
  align-self: center;
  text-align: center;
  display: inline-block;
  margin-right: .6em;
  min-width: 3em;
  min-height: 1.8em;
  line-height: 1.8em;
  border-radius: .2em;
  font-weight: 600;
  font-size: 1em;
  box-shadow: 0px 1px 1px #00000080;
}
.long-name {
  font-weight: 600;
}
.departure-times {
  width: 6em;
  text-align: center;
}

.alerts {
  font-size: .6em;
  border: solid 1px #ffc978;
  background-color: #fff3e1;
  border-radius: .3em;
  padding: .3em .6em;
  margin: .4em 0 .2em;
  display: flex;
  align-items: center;
  max-height: 3.6em;
  overflow: hidden;

  svg {
    height: 1.5em;
    margin-right: .4em;
    fill: #ff9800;
  }
}

.footer {
  display: none;
}

.no-trips {
  margin: 5em 1em;
  text-align: center;
  color: #ff9800;

  svg {
    width: 1.2em;
    height: 1.2em;
    vertical-align: bottom;
    fill: #ff9800;
  }
}

@keyframes tbody_transition {
  0%   { opacity: 1; transform: translateX(0); }
  50%  { opacity: 0; transform: translateX(-.5em); }
  51%  { opacity: 0; transform: translateX(.5em); }
  100% { opacity: 1; transform: translateX(0); }
}

@media only screen and (min-width: 600px) {
  .departures-container {
    overflow: hidden;
  }
  table {
    th {
      padding: .4em .6em;

      &:nth-of-type(2) {
        width: 11em;
        min-width: 11em;
      }
    }
    td {
      padding: .16em .6em;

      &:nth-of-type(2) {
        padding-left: 0;
      }
    }
  }
  .animate {
    animation: tbody_transition .3s;
  }
  .short-name {
    min-width: 4em;
  }
  .long-name {
    //font-weight: 400;
    font-size: inherit;
    max-width: 20em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .headsign {
    font-size: .6em;
    max-width: 33em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .departure-times {
    white-space: nowrap;
    width: auto;
    text-align: left;
  }

  .footer {
    display: block;
    position: fixed;
    bottom: 0px;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    .page-bullet {
      display: inline-block;
      background-color: rgba(50, 61, 72, 0.3);
      width: .4em;
      height: .4em;
      margin: 0 .1em;
      border-radius: 50%;

      &.current {
        background-color: #333e49;
      }
    }
  }

}
</style>